export const blockIconsUiactionsDeleteNew = (
	<span className='material-symbols-outlined'>delete</span>
);
